<template>
    <div class="plan-select-option">
        <div class="plan-name">
            {{ billingPlan.name }}
        </div>

        <ul class="plan-features">
            <li
                v-for="(feature, index) in features"
                :key="index"
                :class="[
                    'plan-feature',
                    `plan-feature-${feature.enabled ? 'enabled' : 'disabled'}`
                ]"
            >
                <span class="plan-feature-icon" />
            </li>
        </ul>

        <button
            class="form-button"
            :class="`is-${colorPalette}`"
            @click="() => onSelect(billingPlan)"
        >
            {{ buttonLabel }}
        </button>
    </div>
</template>
<script>
import usdFormatter from '@/utils/usdFormatter';

export default {
    props: {
        billingPlan: {
            type: Object,
            default: () => ({}),
        },
        featuresList: {
            required: true,
            type: Array,
        },
        colorPalette: {
            required: true,
            type: String,
        },
        onSelect: {
            required: true,
            type: Function,
        },
    },

    computed: {
        /**
         * Gets the list of features.
         *
         * @returns {object[]} List of features.
         */
        features() {
            if (! this.billingPlan.features) {
                return [];
            }

            return this.featuresList.map((feature) => ({
                enabled: this.billingPlan.features.includes(feature),
            }));
        },

        /**
         * Gets the label of button.
         *
         * @returns {string} Button label.
         */
        buttonLabel() {
            const amount = usdFormatter(this.billingPlan.minimalPrice.amount);

            return `Starting at ${amount}/mo`;
        },
    },
};
</script>
<style scoped lang="scss">
    @use './PlanSelectOption.scss';
</style>
